import {useState} from 'react'
import RangeSlider from 'react-bootstrap-range-slider'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
import {Explorer} from '../../Explorer'

export function SizeText({uuid, defaulValue}) {
  const [sizeBorder, setSizeBorder] = useState(defaulValue || 1)

  function onChange(size) {
    Explorer.changeStyle(uuid, 'size-text', parseInt(size))
  }
  return (
    <>
      <div className='item-config'>
        <div className='item-config-align'>
          <div
            data-bs-toggle='collapse'
            data-bs-target={`#collapseExample_${uuid}_texto`}
            aria-expanded='false'
            aria-controls={`collapseExample_${uuid}_texto`}
          >
            <div className='item-config-align-title'>Texto</div>
            {/* <label className='switch pull-right'>
              <input type='checkbox' id='text' name='text' />
              <span className='slider round'></span>
            </label> */}
          </div>
          <div className='border-left-layers w-100 collapse ' id={`collapseExample_${uuid}_texto`}>
            <div className=''>
              <input
                className='form-control'
                type='text'
                value={sizeBorder}
                onChange={(changeEvent) => {
                  let val = changeEvent.target.value
                  setSizeBorder(parseInt(val))
                  onChange(val)
                }}
              />
              <RangeSlider
                value={sizeBorder}
                onChange={(changeEvent) => {
                  let val = changeEvent.target.value
                  setSizeBorder(parseInt(val))
                  onChange(val)
                }}
                min={1}
                max={30}
                step={1}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
